var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiTabs from '@material-ui/core/Tabs';
var Tabs = withStyles(function (theme) { return ({
    root: {
        backgroundColor: theme.palette.background.default,
    },
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        '& > span': {
            maxWidth: 40,
            width: '100%',
            zIndex: 11,
            backgroundColor: theme.palette.primary.main,
        },
    },
}); })(function (props) { return React.createElement(MuiTabs, __assign({}, props, { TabIndicatorProps: { children: React.createElement("span", null) } })); });
export default Tabs;
//# sourceMappingURL=Tabs.js.map